module.exports = __webpack_public_path__ + "img/colorBox1.57807b24.jpg";